import React, {useEffect, useState} from 'react';
import ExportCustomers from '../components/exportCustomers';
import ExportEmployees from '../components/exportEmployees';
import ExportTasks from '../components/exportTasks';
import {loadPermissions} from "../functions/permissions";
import {useNavigate} from "react-router-dom";
import TopNavbar from "../components/Navbar";


function Export() {
    const navigate = useNavigate();
    const [writePermission, setWritePermission] = useState(false);
    const [readPermission, setReadPermission] = useState(false);

    useEffect(() => {
        loadPermissions(navigate, setReadPermission, setWritePermission);
    }, []);

    return (
        <>
            <TopNavbar readPermissionInitial={readPermission} writePermissionInitial={writePermission}/>
            <div className='main'>
                <div className="header">
                    <h2>Daten exportieren</h2>
                </div>
                <ExportTasks></ExportTasks>
                <ExportCustomers></ExportCustomers>
                <ExportEmployees></ExportEmployees>
            </div>
        </>
    );
}

export default Export;